import { render, staticRenderFns } from "./MosCheckSwitch.vue?vue&type=template&id=83dd3fb0"
import script from "./MosCheckSwitch.vue?vue&type=script&lang=js"
export * from "./MosCheckSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports